import React                   from 'react'
import { withRouter          } from 'react-router'
import { Nav, NavItem        } from 'react-bootstrap'
import IdleTimer               from 'react-idle-timer'
import PropTypes               from 'prop-types'
import { NavbarText, NavLink } from 'alto-react-components/lib/components'
import { withAuthMessage     } from 'alto-react-base-auth/lib/utils'
import { sessionSetting      } from 'alto-react-base-auth/lib/settings'

class UserBar extends React.Component
  @contextTypes = { auth: PropTypes.object, settings: PropTypes.object }

  render: ->
    <Nav pullRight>
      {@text()}
      {@navLinks()}
      {@idleTimer()}
    </Nav>

  text: ->
    <NavbarText id='user-info' className='hidden-xs'>
      Přihlášen jako {@userSignature()}
    </NavbarText>

  navLinks: ->
    <React.Fragment>
      <NavItem id='logout-link' onClick={=> @logOut()}>Odhlásit</NavItem>
    </React.Fragment>

  idleTimer: ->
    setting  = sessionSetting(@context.settings)
    expireIn = if @context.auth.isTerminal then setting.expireInTerminal else setting.expireIn

    <IdleTimer onIdle={=> @logOut('session_expired', 'warning')} timeout={expireIn.asMilliseconds()} />

  logOut: (message, messageType) ->
    @beforeLogOut()
    @context.auth.logOut()

    @props.history.push(withAuthMessage('/', message, messageType))

  beforeLogOut: ->

  userSignature: ->
    user = @context.auth.loggedInUser

    user.username + (if user.fullName.length then " (#{user.fullName})" else '')

export default UserBar = withRouter(UserBar)
